<template>
    <div
        style="display: flex;padding-top: 1.5rem; padding-bottom: 1.5rem;justify-content: start; text-align: left;padding: 28px; background: #f5f7f9;width:100%">
        <div style="width: 100%;">
            <div style="padding-bottom: 1.5rem;">
                <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">Developer Info(For reviewer's
                    ref):</div>
                <div class="flex w-full">
                    <span class="font-medium">Name:&nbsp;</span>
                    <span>{{ app.dev.name }}</span>
                </div>
                <div class="flex w-full">
                    <span class="font-medium">Email:&nbsp;</span>
                    <span>{{ app.dev.email }}</span>
                </div>
            </div>
            <div style="padding-bottom: 1.5rem;">
                <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">Description:</div>
                <div v-if="app.description && app.description.length > 0" id="app-description">
                    <p v-html="app.description" />
                </div>
                <div v-else>-</div>
            </div>
            <div style="padding-bottom: 1.5rem;">
                <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">SubAccount Description:</div>
                <div v-if="app.subAccountDescription && app.subAccountDescription > 0" id="app-description">
                    <p v-html="app.subAccountDescription" />
                </div>
                <div v-else>-</div>
            </div>
            <div style="padding-bottom: 1.5rem;">
                <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">Category:</div>
                <div v-if="app.subcategory" class="truncate">
                    {{ app.subcategory }}
                </div>
                <div v-else>-</div>
            </div>
            <div style="padding-bottom: 1.5rem;">
                <div style="display: inline;padding-bottom: 1rem;" class="heading-font">Scopes:</div>
                <div v-if="app.allowedScopes && app.allowedScopes.length > 0"
                    style="display: flex; gap: 0.5rem;flex-wrap: wrap; ">
                    <div v-for="(scope, index) in app.allowedScopes" class="tag info">{{ scope }}</div>
                </div>
                <div v-else>-</div>
            </div>
            <div style="padding-bottom: 1.5rem;">
                <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">Redirect URLs:</div>
                <div v-if="app.redirectUris && app.redirectUris.length" class="truncate"
                    v-for="(url, index) in app.redirectUris"><a :href="url" target="_blank">{{ url }}</a></div>
                <div v-if="app.redirectUris.length === 0"> - </div>
            </div>
            <div style="padding-bottom: 1.5rem;">
                <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">Website:</div>
                <div v-if="app.website" class="truncate"><a :href="app.website" target="_blank">{{ app.website }}</a>
                </div>
                <div v-else>-</div>
            </div>

            <div style="padding-bottom: 1.5rem;">
                <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">Support Email:</div>
                <div v-if="app.supportConfig?.supportEmail" class="truncate">{{ app.supportConfig.supportEmail }}</div>
                <div v-else>-</div>
            </div>

            <div style="padding-bottom: 1.5rem;">
                <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">Support Phone:</div>
                <div v-if="app.supportConfig?.supportPhone" class="truncate">{{ app.supportConfig.supportPhone }}</div>
                <div v-else>-</div>
            </div>

            <div style="padding-bottom: 1.5rem;">
                <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">Documentation URL:</div>
                <div v-if="app.supportConfig?.documentationUrl" class="truncate"><a
                        :href="app.supportConfig.documentationUrl" target="_blank">{{
                            app.supportConfig.documentationUrl }}</a></div>
                <div v-else>-</div>
            </div>

            <div style="padding-bottom: 1.5rem;">
                <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">Support Website:</div>
                <div v-if="app.supportConfig?.websiteUrl" class="truncate"><a :href="app.supportConfig.websiteUrl"
                        target="_blank">{{ app.supportConfig.websiteUrl }}</a></div>
                <div v-else>-</div>
            </div>

            <div style="padding-bottom: 1.5rem;">
                <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">Custom Pages:</div>
                <div v-if="app.customPages.length" class="truncate"><a :href="app.customPages[0].liveUrl"
                        target="_blank">{{ app.customPages[0].title }}</a></div>
                <div v-else>-</div>
            </div>
            <div style="padding-bottom: 1.5rem;">
                <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">App preview images:</div>
                <div v-if="app.previewImageUrls && app.previewImageUrls.length > 0" class="container-box">
                    <div class="col-main">
                        <div class="slider-container">
                            <div class="slider">
                                <div style="width: 18rem;height: 10rem;background-color: #D1D5DB"
                                    v-for="(url, index) in app.previewImageUrls">
                                    <img :src="url" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>-</div>
            </div>
            <div style="padding-bottom: 1.5rem;">
                <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">SubAccount preview images:
                </div>
                <div v-if="app.subAccountPreviewImageUrls && app.subAccountPreviewImageUrls.length > 0"
                    class="container-box">
                    <div class="col-main">
                        <div class="slider-container">
                            <div class="slider">
                                <div style="width: 18rem;height: 10rem;background-color: #D1D5DB"
                                    v-for="(url, index) in app.subAccountPreviewImageUrls">
                                    <img :src="url" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>-</div>
            </div>
            <div style="padding-bottom: 1.5rem;">
                <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">App preview Video:</div>
                <div v-if="app.previewVideoUrl" class="container-box">
                    <div class="col-main">
                        <div class="slider-container">
                            <div class="slider">
                                <div>
                                    <div style="padding: 1rem 0rem;">
                                        <a :href="app.previewVideoUrl" target="_blank">App Preview Video Url</a>
                                    </div>
                                    <div style="height: 320px; width: 600px">
                                        <iframe width="560" height="315"
                                            :src="`https://www.youtube.com/embed/${getVideoId(app.previewVideoUrl)}?rel=0`"
                                            frameborder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation"
                                            allowfullscreen>
                                        </iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>-</div>
            </div>
            <div style="padding-bottom: 1.5rem;">
                <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">SubAccount preview Video:
                </div>
                <div v-if="app.subAccountPreviewVideoUrl" class="container-box">
                    <div class="col-main">
                        <div class="slider-container">
                            <div class="slider">
                                <div>
                                    <div style="padding: 1rem 0rem;">
                                        <a :href="app.subAccountPreviewVideoUrl" target="_blank">App Preview Video
                                            Url</a>
                                    </div>
                                    <div style="height: 320px; width: 600px">
                                        <iframe width="560" height="315"
                                            :src="`https://www.youtube.com/embed/${getVideoId(app.subAccountPreviewVideoUrl)}?rel=0`"
                                            frameborder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation"
                                            allowfullscreen>
                                        </iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>-</div>
            </div>
            <div style="padding-bottom: 1.5rem;">
                <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">Is Paid App:</div>
                <div v-if="app.description && app.description.length > 0" id="app-description">
                    <p v-html="app.isPaidApp ? 'Yes' : 'No'" />
                </div>
                <div v-else>-</div>
            </div>
            <div v-if="app.isPaidApp" style="padding-bottom: 1.5rem;">
                <div>
                    <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">Is Externally Billed:
                    </div>
                    <div v-if="app.description && app.description.length > 0" id="app-description">
                        <p v-html="app.externalBilling ? 'Yes' : 'No'" />
                    </div>
                    <div v-else>-</div>
                </div>

                <div v-if="app.externalBilling">
                    <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">External Billing Url:
                    </div>
                    <div v-if="app.description && app.description.length > 0" id="app-description">
                        <p v-html="app.externalBillingUrl" />
                    </div>
                    <div v-else>-</div>
                </div>

                <div v-else>
                    <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">Payment Plans:</div>
                    <table class="table table-bordered table-hover">
                        <thead class="thead-dark">
                            <tr>
                                <th scope="col">Plan Id</th>
                                <th scope="col">Plan Name</th>
                                <th scope="col">Amount</th>
                                <th scope="col">Features</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="plan in plans" :key="plan._id">
                                <td>{{ plan._id }}</td>
                                <td>{{ plan.name }}</td>
                                <td>{{ plan.amount }}</td>
                                <td>{{ plan?.features?.join(', ') }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { IntegrationsService } from '@/services'
import { getVideoId } from './helpers/video.ts'

export default {
    props: {
        data: Object
    },
    computed: {
        app: {
            get() {
                return this.data
            }
        }
    },
    data() {
        return {
            plans: []
        }
    },
    methods: {
        formatTime(time) {
            return moment(time).format(
                "MMM DD, YYYY"
            )
        },
        async getPaymentPlans() {
            try {
                const response = await IntegrationsService.getPaymentPlans(this.app.appId)
                this.plans = response.data
            } catch (err) {
                console.error(err)
            }
        },
        getVideoId(url) {
            return getVideoId(url)
        }
    },
    mounted() {
        if (this.app?.isPaidApp) {
            this.getPaymentPlans()
        }
    }
};
</script>
<style scoped>
.heading-font {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    color: #374151;
}

.subtitle-font {
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: #6B7280;
}

.toCapitalFirst {
    text-transform: capitalize;
}

.tag {
    border-radius: 13px;
    color: white;
    text-align: center;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}

.info {
    color: #344054;
    background: #F2F4F7;
    mix-blend-mode: multiply;
}

.success {
    background: #12B76A;
}

.danger {
    background: #D92D20;
}

.danger-btn {
    background: #FEF3F2;
    color: #B42318;
}

.warning {
    background: #F79009;
}

.truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.container-box {
    display: flex;
    justify-items: start;
    width: 100%;
}

.col-main {
    flex: 1 1 100%;
    width: 0;
}

.slider-container {
    overflow: hidden;
    overflow-x: scroll;
}

.slider-container .slider {
    display: inline-flex;
    gap: 1rem;
}

.slider-container .slider img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
</style>
